import { render, staticRenderFns } from "./LotProfileComponent.vue?vue&type=template&id=06dd85a8&"
import script from "./LotProfileComponent.vue?vue&type=script&lang=js&"
export * from "./LotProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./LotProfileComponent.vue?vue&type=style&index=0&id=06dd85a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports